export default function loadGoogleMapsApi(apiKey) {
  return new Promise((resolve, reject) => {
    if (
      typeof window.google === "object" &&
      typeof window.google.maps === "object"
    ) {
      resolve();
      return;
    }

    if (
      document.querySelector(`script[src*="maps.googleapis.com/maps/api/js"]`)
    ) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
    script.async = true;
    script.defer = true;
    script.setAttribute("loading", "async");
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}
